<template>
  <div
    class="i-announcement-bar"
    :class="props.version"
  >
    <img
      class="logo"
      loading="lazy"
      alt="Jobtest Logo"
      :src="logo"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import logoWhite from "@/assets/logo/logo-white.svg"
import logoDark from "@/assets/logo/logo-dark.svg"

// Props
const props = defineProps({
  version: {
    type: String,
    default: "dark",
    validator: (value: string) => value === "light" || value === "dark"
  }
})

// Computed
const logo = computed(() => {
  return props.version === "light" ? logoDark : logoWhite
})
</script>

<style scoped lang="scss">
.i-announcement-bar {
  @include flex($direction: row, $justify: center, $align: center);

  height: 50px;
  z-index: $z-index-header;

  &.light {
    background-color: $white;
  }

  &.dark {
    background-color: $black;
  }

  .logo {
    height: 28px;
  }

  @media screen and (min-width: $breakpoint-md) {
    height: 60px;
  }
}
</style>
